import { Typography, VertTypography } from '@vertem-core/vertice-ds';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { convertPoints } from 'Utils/maskFormat';
import { useMediaQuery } from 'react-responsive';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';
import { useSelector } from 'react-redux';

const ValuePriceForPoint = ({ price }) => {
  const [priceProductTable, setPriceProductTable] = useState(0);
  const [loading, setLoading] = useState(true);
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);

  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];

  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };

  const mediaQuery = useMediaQuery({ query: '(max-width: 768px)' });

  const fetchPriceForPoint = async () => {
    setLoading(true);
    try {
      const { data } = await redemptionsApiClient.get(
        `Product/ConvertedPrice?price=${price}`,
        {
          headers: config,
        }
      );
      setPriceProductTable(data.points);
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPriceForPoint();
  }, [price]);

  return loading ? (
    <VertTypography.Text>Carregando...</VertTypography.Text>
  ) : (
    <Typography.Text
      style={{
        fontSize: mediaQuery ? '12px' : '14px',
        fontWeight: 'bold',
      }}
    >
      {convertPoints(priceProductTable, 0)} pontos
    </Typography.Text>
  );
};

export default ValuePriceForPoint;

ValuePriceForPoint.propTypes = {
  price: PropTypes.number.isRequired,
};
